/**
 * @param  {String} name Name of the cookie to read
 * @return {Any} value
 */
export default function readCookie(name) {
  const cookies = document.cookie.split(/;\s*/);
  let value = false;

  cookies.forEach((cookie) => {
    if (!cookie.indexOf(`${name}=`)) {
      value = cookie.replace(`${name}=`, '');
    }
  });

  return value;
}



// WEBPACK FOOTER //
// ./assets/js/components/cookie.js